import api from './client';

// Очередь на пост замены масла (oil_change_queue.md §4)
// Rev. 2026-09-10: статус on_post упразднён, кнопки «Взять на пост» нет

export interface OilQueueItem {
  order_id: number;
  status: 'queued' | 'not_queued';
  position: number | null;
  entered_at?: string | null;  // null у not_queued (записи в очереди нет)
  started_at?: string | null;
  order_number?: string | null;
  order_status: string;
  order_type: 'service_order' | 'oil_change';
  posted: boolean;
  license_plate?: string | null;
  vehicle?: string | null;
  client?: string | null;
  total?: number | null;
  our_oil?: boolean;  // true — масло наше (зелёная канистра), false — клиент со своим (синяя)
  bulk_oil?: boolean; // true — в заказе разлив из бочки (зелёная бочка вместо канистры)
  deletion_state?: 'pending' | 'done' | null;  // пометка на удаление (service_order_deletion.md)
}

export interface LastExecutor {
  id: string;
  name: string;
}

export interface OilQueueResponse {
  items: OilQueueItem[];
  // Все непроведённые замены масла вне очереди (rev. 2026-09-11)
  not_queued: OilQueueItem[];
}

export const getQueue = (): Promise<OilQueueResponse> =>
  api.get<OilQueueResponse>('/oil-change/queue').then(r => r.data);

// Исполнители последней сегодняшней замены масла — предзаполнение поля
// «Исполнители» в новой заявке (OilChangePage.md §3Г)
export const getLastExecutors = (): Promise<LastExecutor[]> =>
  api.get<{ executors: LastExecutor[] }>('/oil-change/last-executors').then(r => r.data.executors);

export const enqueueOrder = (orderId: number): Promise<void> =>
  api.post(`/oil-change/queue/${orderId}`).then(() => undefined);

export const finishOrder = (orderId: number): Promise<void> =>
  api.post(`/oil-change/queue/${orderId}/finish`).then(() => undefined);

export const removeFromQueue = (orderId: number): Promise<void> =>
  api.delete(`/oil-change/queue/${orderId}`).then(() => undefined);
